module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('span', [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_iv",
      "title": "iv"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_v",
      "title": "v"
    }
  }, [_vm._v("Contents")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "rfm1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Acknowledgments#fm1"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "rfm2"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Notes_on_the_Text#fm2"
    }
  }, [_vm._v("Notes on the Text")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "rfm3"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Prologue#fm3"
    }
  }, [_vm._v("American Prologue: Mother and Daughter")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "rfm4"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Amsterdam#fm4"
    }
  }, [_vm._v("Amsterdam: July 1943, Dawn")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "rch1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter001#ch1"
    }
  }, [_vm._v("1.")]), _c('span', {
    staticClass: "spacec"
  }), _c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter001#ch1"
    }
  }, [_vm._v("Berlin")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "rch2"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter002#ch2"
    }
  }, [_vm._v("2.")]), _c('span', {
    staticClass: "spacec"
  }), _c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter002#ch2"
    }
  }, [_vm._v("Berlin and Amsterdam")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "rch3"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter003#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.")]), _c('span', {
    staticClass: "spacec"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter003#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Mother Comes of Age")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "rch4"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter004#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.")]), _c('span', {
    staticClass: "spacec"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter004#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Invasion, Amsterdam 1940")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "rch5"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter005#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.")]), _c('span', {
    staticClass: "spacec"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter005#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the Ardennes, 1943")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "rch6"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter006#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.")]), _c('span', {
    staticClass: "spacec"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter006#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bergen-Belsen, April 1945")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "rch7"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter007#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.")]), _c('span', {
    staticClass: "spacec"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter007#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Displaced Persons, Bergen-Belsen")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "rch8"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter008#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.")]), _c('span', {
    staticClass: "spacec"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter008#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Love Letters: Amsterdam, Basel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "rch9"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter009#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.")]), _c('span', {
    staticClass: "spacec"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter009#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("War Again, Israel 1948")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chaptera",
    attrs: {
      "id": "rch10"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter010#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.")]), _c('span', {
    staticClass: "spacec"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter010#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An American in Germany, 1971")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "rbm1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Epilogue#bm1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "rbm2"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#bm2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0df69bd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Contents.vue
// module id = 66
// module chunks = 0